import React from 'react'
import theme from 'redesign/themes/main'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const SuccessCircleCheckIcon: React.FC<IconProps> = ({
  color = theme.palette.success.main,
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
  fillOpacity,
  isFilled = false,
}) => {
  const icon = isFilled ? (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12c0 2.6522 1.05357 5.1957 2.92893 7.0711C6.8043 20.9464 9.34784 22 12 22c2.6522 0 5.1957-1.0536 7.0711-2.9289C20.9464 17.1957 22 14.6522 22 12c0-2.65216-1.0536-5.1957-2.9289-7.07107C17.1957 3.05357 14.6522 2 12 2 9.34784 2 6.8043 3.05357 4.92893 4.92893 3.05357 6.8043 2 9.34784 2 12Zm14.841-3.03823c.255-.32641.1971-.79775-.1293-1.05275-.3264-.25501-.7977-.19713-1.0527.12928l-4.9296 6.3099-2.68224-2.8611c-.2833-.3022-.75793-.3175-1.06011-.0342-.30219.2833-.3175.7579-.0342 1.0601l3.28125 3.5c.1498.1598.362.2461.5809.2363.2188-.0099.4224-.1149.5573-.2875l5.4687-7.00003Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  ) : (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12c0 2.6522 1.05357 5.1957 2.92893 7.0711C6.8043 20.9464 9.34784 22 12 22c2.6522 0 5.1957-1.0536 7.0711-2.9289C20.9464 17.1957 22 14.6522 22 12c0-2.65216-1.0536-5.1957-2.9289-7.07107C17.1957 3.05357 14.6522 2 12 2 9.34784 2 6.8043 3.05357 4.92893 4.92893 3.05357 6.8043 2 9.34784 2 12Zm1.5 0c0 2.2543.89553 4.4163 2.48959 6.0104C7.58365 19.6045 9.74566 20.5 12 20.5c2.2543 0 4.4163-.8955 6.0104-2.4896C19.6045 16.4163 20.5 14.2543 20.5 12c0-2.25434-.8955-4.41635-2.4896-6.01041C16.4163 4.39553 14.2543 3.5 12 3.5c-2.25434 0-4.41635.89553-6.01041 2.48959C4.39553 7.58365 3.5 9.74566 3.5 12Zm13.341-3.03823c.255-.32641.1971-.79775-.1293-1.05275-.3264-.25501-.7977-.19713-1.0527.12928l-4.9296 6.3099-2.68224-2.8611c-.2833-.3022-.75793-.3175-1.06011-.0342-.30219.2833-.3175.7579-.0342 1.0601l3.28125 3.5c.1498.1598.362.2461.5809.2363.2188-.0099.4224-.1149.5573-.2875l5.4687-7.00003Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  )

  return (
    <SvgWrapper aria-label="SuccessCircleCheckIcon" size={size} viewBox={viewBox} fill="none">
      {icon}
    </SvgWrapper>
  )
}

export default SuccessCircleCheckIcon
